import find from 'lodash.find';
import PropTypes from 'prop-types';
import useEpisodes from '../../../pages/shows/[channel_slug]/common/hooks/useEpisodes';
import useShow from '@/hooks/shows/useShowFromURL';
import { createSDMusicAlbumForShow, createSDMusicRecordingForShowEpisode } from '@/helpers/structured-data/shows';
import Meta from '@/components/app/Meta';
import { SHARING } from '@/config/assets';
import { isEqualAsNumber } from '@/helpers/math';
import { extractImgFromAssetObj } from '@/helpers/assets';
import { createShowPageTitle, createShowPageDescription } from '@/helpers/seo/shows';

const ShowMeta = ({
  showSlug,
  showId,
  episodeNumber,
  seasonNumber,
  ...props
}) => {
  const { show } = useShow();
  const { episodes } = useEpisodes();
  const {
    external_links: showLinks,
    assets: showAssets
  } = show || {};

  const episode = find(
    episodes,
    (e) => (
      isEqualAsNumber(e.episode_number, episodeNumber)
        && isEqualAsNumber(e.season, seasonNumber)
    )
  ) || {};

  return (
    <Meta
      description={ createShowPageDescription({
        show,
        episode,
        augmentDescription: true
      }) }
      sharingDescription={ createShowPageDescription({
        show,
        episode
      }) }
      sharingImage={ extractImgFromAssetObj({
        assetsObj: showAssets,
        imageType: SHARING
      }).image }
      sharingTitle={ createShowPageTitle({
        show,
        episode
      }) }
      structuredData={ [
        episodeNumber ? {
          id: 'episode',
          data: createSDMusicRecordingForShowEpisode({ episode })
        } : {
          id: 'show',
          data: createSDMusicAlbumForShow({ show })
        }
      ] }
      title={ createShowPageTitle({
        show,
        episode,
        addHosts: true
      }) }
      twitterUrl={ (showLinks || []).find(((l) => (l.platform === 'twitter')))?.url || '' }
      useTitleRaw
      { ...props }
    />
  );
};

ShowMeta.propTypes = {
  showSlug: PropTypes.string,
  episodeNumber: PropTypes.number,
  seasonNumber: PropTypes.number,
  showId: PropTypes.string
};

ShowMeta.defaultProps = {
  showSlug: '',
  episodeNumber: null,
  seasonNumber: null,
  showId: ''
};

export default ShowMeta;